module.exports = __webpack_public_path__ + "img/Index／Delete default.1110d4c4.svg";